import { apiClient } from '../client'
import { ExportAdsPayload, ExportPortal, ExportSync, ExportWebsite } from './types'

export const getExportPortals = async (): Promise<ExportPortal[]> => {
    const response = await apiClient('v1/export/portals')
    return response.data
}

export const getExportWebsites = async (): Promise<ExportWebsite[]> => {
    const response = await apiClient('v1/export/websites')
    return response.data
}

export const getExportSync = async (): Promise<ExportSync> => {
    const response = await apiClient('v1/export/synchronization')
    return response.data
}

// GET, but wired to a mutation hook: hitting this endpoint starts a sync job server-side and
// returns the resulting status, so it must only fire on an explicit user action, never via a
// query's automatic refetch/retry/invalidate paths. timeout: 0 because the sync itself can run long.
export const triggerExportSync = async (): Promise<ExportSync> => {
    const response = await apiClient('v1/export/synchronize', {
        timeout: 0,
    })
    return response.data
}

export const handleAdsExport = async (payload: ExportAdsPayload) => {
    const response = await apiClient('v1/export/portal-marking', {
        method: 'POST',
        data: payload,
    })

    return response.data
}
